import {$$} from '@vue-macros/reactivity-transform/macros'

import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'
import {
  IBooleanPropertyTypeInterfaces,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/BooleanPropertyTypeStrategy/types/IBooleanPropertyTypeInterfaces'
import {DatabaseViewType} from '@toolify/server/src/models/mongoose/DatabaseViewModel/enum/DatabaseViewType'
import {GroupSortModeType} from '@toolify/server/src/services/DatabasePropertyService/enum/GroupSortModeType'
import {COMMON_GROUP_SORT_LABEL_KEYS} from '@toolify/client/src/modules/databases/utils/groupSortModes'

export function useBooleanValueTypeStrategy() {

  const fullValueToText = (value: IBooleanPropertyTypeInterfaces['fullValue'], property: IDatabasePropertyResponseInstance) => {
    if(![true, false].includes(value)) {
      return ''
    }
    return value ? 'true' : 'false'
  }

  // Gantt groups by a Boolean too (K18: „Kamień milowy”, „Termin ustalony”); keep canGroupGanttViewByProperty equal
  const canGroupByView = (viewType: DatabaseViewType, _property: IDatabasePropertyResponseInstance) =>
    viewType === DatabaseViewType.Table || viewType === DatabaseViewType.Kanban || viewType === DatabaseViewType.Gantt

  const compareItemValues = (
    valueA: IBooleanPropertyTypeInterfaces['fullValue'],
    valueB: IBooleanPropertyTypeInterfaces['fullValue'],
    sortDirection: '1' | '-1',
  ): number => {
    const numA = valueA === true ? 1 : 0
    const numB = valueB === true ? 1 : 0
    const comparison = numA - numB
    return sortDirection === '1' ? comparison : -comparison
  }

  const groupSort = {
    availableModes: [GroupSortModeType.ValueDesc, GroupSortModeType.ValueAsc],
    defaultMode: GroupSortModeType.ValueDesc,
    getLabelKey: (mode: GroupSortModeType): string => {
      if(mode === GroupSortModeType.ValueDesc) return 'database.header.groupSort.checkedFirst'
      if(mode === GroupSortModeType.ValueAsc) return 'database.header.groupSort.uncheckedFirst'
      return COMMON_GROUP_SORT_LABEL_KEYS[mode]
    },
  }

  return $$({
    fullValueToText,
    canGroupByView,
    compareItemValues,
    groupSort,
  })
}
